<template>
  <div>
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="350"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar
            color="blue"
            size="46"
          >
            <v-icon
              color="white"
              size="30"
            >
              mdi-credit-card-wireless
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Restaurant.Tables.Dialog.SelectInstalments.Title') }}
            </div>
            <div class="text-caption">
              {{ $t('Restaurant.Tables.Dialog.SelectInstalments.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="mt-4">
          <v-select
            v-model="instalments"
            :items="[1,2,3,4,5,6,7,8,9,10,11,12,24,36,48]"
            :label="$t('Restaurant.Tables.Dialog.SelectInstalments.Subtitle')"
            filled
            hide-details
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            text
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel') }}
          </v-btn>

          <v-btn
            color="primary"
            depressed
            @click="onSelectInstalments"
          >
            {{ $t('Common.Button.Ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppData from '@/mixins/appdata'

export default {
  name      : 'SelectPaymentInstalmentsDialog',
  components: {},
  mixins    : [AppData],
  props     : {
    terminal: {
      type   : Object,
      default: undefined
    },
    visible: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {
      instalments: 1
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    isVisible(val) {
      if (val) this.instalments = 1
    }
  },
  methods: {
    onSelectInstalments() {
      this.isVisible = false
      this.$emit('instalments:selected', this.terminal, this.instalments ?? 0)
    },

    onCancelButtonClick() {
      this.isVisible = false
    }
  }
}
</script>
